<template>
    <v-container class="pa-0">
        <!-- d-flex flex-nowrap justify-center -->
        <v-progress-circular v-if="spinner" :class="$vuetify.breakpoint.mobile ? 'mobile-centered-progress' : 'centered-progress'" :style="$vuetify.breakpoint.mobile ? 'margin-top: -25px' : 'margin-top: -100px'" :size="$vuetify.breakpoint.mobile ? 100 : 200" indeterminate></v-progress-circular>
        <v-row>
            <v-col cols="12" class="ts-nft-create-progress d-flex justify-center pa-0">
                <v-stepper
                           :v-show="step"
                           :non-linear="NODE_ENV === 'production' ? false : true"
                           flat
                           v-model="stepper"
                           vertical>
                    <v-stepper-step :editable="NODE_ENV === 'production' ? false : true"
                                    :complete="step > 1"
                                    :edit-icon="mdiCheckboxMarkedCircleOutline"
                                    :complete-icon="mdiCheckboxMarkedCircleOutline"
                                    :class="step > 1 ? 'v-stepper__step_completed' : ''"
                                    step="1">
                        <div v-if="step === 1 && !complete" class="text-caption">Waiting for completed form...</div>
                        <div v-else-if="step > 1 || complete">Step 1 Complete.
                            <small>Form Completed</small>
                        </div>
                        <small></small>
                    </v-stepper-step>
                    <v-stepper-content step="1">
                        <v-list v-model="inputs" dense>
                            <v-list-item class="d-flex justify-center text-uppercase text-subtitle-2" :class="{ 'validated': input.validate(), 'no-easing': formValue }" v-for="input of formInputs" :key="input.id">
                                <v-row>
                                    <v-col class="d-flex align-center justify-end" cols="7">{{ input.id.replace(/^bra_/, '') }}</v-col>
                                    <v-col class="d-flex align-center justify-start">
                                        <span style="font-size: xx-large; color: #4CAF50" v-if="input.validate()">🗸</span>
                                        <span class="text-md-h5" v-else>⬜</span>
                                    </v-col>
                                </v-row>
                            </v-list-item>
                        </v-list>
                        <div class="text-h5" v-if="formValue">
                            <div class="d-flex align-center mb-4"><span class="text-md-h3">🔥</span>Completed!</div>
                            <p class="text-body-2">Click <span style="color: green" class="text-uppercase font-weight-medium">create</span> when you're ready.</p>
                        </div>
                    </v-stepper-content>

                    <v-stepper-step :editable="NODE_ENV === 'production' ? false : true"
                                    :complete="step > 2"
                                    :edit-icon="mdiCheckboxMarkedCircleOutline"
                                    :complete-icon="mdiCheckboxMarkedCircleOutline"
                                    :class="step > 2 ? 'v-stepper__step_completed' : ''"
                                    step="2">
                        <div v-if="step === 2 && !complete">Creating BraNFT™ Pre Mint...</div>
                        <div v-else-if="step > 2 || complete">Step 2 Complete.
                            <small>BraNFT™ Pre Mint Created</small>
                        </div>
                    </v-stepper-step>
                    <v-stepper-content step="2">
                        <v-progress-circular width="1" size="64" :v-show="step === 2 && !complete" indeterminate></v-progress-circular>
                    </v-stepper-content>

                    <v-stepper-step :editable="NODE_ENV === 'production' ? false : true"
                                    :complete="step > 3 || complete"
                                    :edit-icon="mdiCheckboxMarkedCircleOutline"
                                    :complete-icon="mdiCheckboxMarkedCircleOutline"
                                    :class="step > 3 || complete ? 'v-stepper__step_completed' : ''"
                                    step="3">
                        <div v-if="step === 3 && !complete">Minting BraNFT™...</div>
                        <div v-else-if="step > 3 || complete">Step 3 Complete.
                            <small>BraNFT™ Minted</small>
                        </div>
                    </v-stepper-step>
                    <v-stepper-content step="3">
                        <v-progress-circular width="1" size="64" :v-show="step === 3 && !complete" indeterminate></v-progress-circular>
                    </v-stepper-content>
                </v-stepper>
            </v-col>
        </v-row>
        <v-row v-if="this.step > 3">
            <v-col cols="12">
                <ts-nft-widget-share hover class="my-4" header="Congratulations!🎉" :nft-component="{ nft }"></ts-nft-widget-share>
            </v-col>
        </v-row>
    </v-container>
</template>
<style scoped>
.validated {
    opacity: 0;
    height: 0;
    min-height: 0;
    transition: opacity 3s ease-in-out, min-height ease-in-out;
    transition-property: opacity, min-height;
    transition-delay: 0s, 3s;
}
.no-easing {
    transition: none !important;
}
</style>
<style>
.mobile-centered-progress {
    position: fixed;
    top: 50%;
    z-index: 1;
}
.centered-progress {
    position: absolute;
    top: 50%;
    margin: auto;
    z-index: 1;
}
a.share-network-sms > span > svg {
}
a.share-network-email > span > svg {
}
a.share-network-facebook > span > svg {
    fill: #1877f2;
}
a.share-network-whatsapp > span > svg {
    fill: #25d366;
}
a.share-network-twitter > span > svg {
    fill: #1da1f2;
}
a.share-network-pinterest > span > svg {
    fill: #bd081c;
}
.ts-nft-create-progress .v-icon {
    size: x-large;
    color: black !important;
}
.ts-nft-create-progress .v-icon__svg {
    height: 40px;
    width: 40px;
}
.ts-nft-create-progress .v-stepper__step_completed span {
    background-color: white !important;
}
</style>
<script>
import Vue from "vue";
import VueSocialSharing from "vue-social-sharing";
import TsNftWidgetShare from "../components/TsNftWidgetShare.vue";

Vue.use(VueSocialSharing);
import {
    mdiPencil,
    mdiCheckboxMarkedCircleOutline,
    mdiCheckboxBlankOutline,
    mdiTwitter,
    mdiFacebook,
    mdiWhatsapp,
    mdiEmail,
    mdiPhoneMessage,
    mdiPinterest,
} from "@mdi/js";

export default {
    name: "TsNftCreateProgress",
    components: {
        TsNftWidgetShare,
    },
    props: {
        step: Number,
        form: Object,
        nft: Object,
        reset: Boolean,
    },
    methods: {},
    data: function () {
        return {
            NODE_ENV: process.env.NODE_ENV,
            mdiPencil,
            mdiCheckboxMarkedCircleOutline,
            mdiCheckboxBlankOutline,
            mdiTwitter,
            mdiFacebook,
            mdiWhatsapp,
            mdiEmail,
            mdiPhoneMessage,
            mdiPinterest,
            inputs: null,
            share: {
                url: this.nft
                    ? `https://${
                          document.domain.match(/[^.]*.com/)[0]
                      }/braNFT/${nft.token_id}`
                    : "",
                title: "I turned my bra into a BraNFT™",
                description: this.description,
                quote: `BraNFT™s combine crypto and physical assets... literally.`,
                hashtags: "BraNFT™,bra,nft",
            },
            complete: false,
            spinner: false,
        };
    },
    computed: {
        first() {
            // get from db?  Somewhere...
            return true;
        },
        stepper() {
            return this.step;
        },
        description() {
            return this.nft
                ? `${this.nft.description.match(/[^.]*\./)}...`
                : "";
        },
        shareUrl() {
            return this.share.url;
        },
        formInputs() {
            return this.form && this.form.$data ? this.form.$data.inputs : undefined;
        },
        formValue() {
            return this.form ? this.form.value : undefined;
        },
    },
    mounted() {},
    watch: {
        step(value) {
            if (value > 3) this.complete = true;
        },
        reset() {
            this.complete = false;
            this.step = 1;
            this.$emit("reset");
        },
        nft(value) {
            this.share.url =
                value && value.token_id
                    ? `https://${
                          document.domain.match(/[^.]*.com/)[0]
                      }/braNFT/${value.token_id}`
                    : "";
        },
    },
};
</script>
